export default "<cx-quote-summary [cart]=\"cart$ | async\" [entries]=\"entries$ | async\"></cx-quote-summary>\n"